angular.module('agreements')
    .component('agreementTimeStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span class="label label-default agreement-time-status {{$ctrl.status}}" ng-if="$ctrl.status != null">{{ 'agreement.time-status.'.concat($ctrl.status) | translate }}</span>
        `
    })
